import Icon from '../components/Icon.vue'

Icon.register({"phone-slash":{"width":640,"height":512,"paths":[{"d":"M268.2 381.4L218.6 320.8C211.8 312.5 200.4 309.7 190.6 313.9L78.6 361.9C67.9 366.5 62.1 378 64.7 389.4L88.7 493.4C91.2 504.2 100.8 512 112.1 512 212.8 512 305.8 479.6 381.8 425.1L301.8 363.3C290.9 369.8 279.7 376 268.2 381.4zM633.8 458.1L475.1 335.5C537.9 256.4 576 156.9 576 48 576 36.8 568.3 27.1 557.4 24.6L453.4 0.6C442.1-2 430.5 3.9 425.9 14.5L377.9 126.5C373.7 136.3 376.5 147.8 384.8 154.5L445.4 204.1C433.2 230.2 417.5 254.4 399.4 276.9L45.5 3.4C38.5-2 28.5-0.8 23 6.2L3.4 31.4C-2 38.4-0.8 48.4 6.2 53.8L594.6 508.5C601.6 513.9 611.6 512.7 617.1 505.7L636.7 480.4C642.1 473.6 640.8 463.5 633.8 458.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/phone-slash.js
// module id = null
// module chunks = 